var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c(
        "template",
        { slot: "primaryActions" },
        [
          _c("app-button", {
            attrs: {
              "is-back-button": true,
              "return-url": _vm.returnUrl,
              variant: "secondary",
              outline: true,
              size: "md",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-container",
            { attrs: { fluid: "" } },
            [
              _vm.activateSpinner
                ? _c("spinner")
                : _c("biconus-form", {
                    attrs: { mode: _vm.mode, readonly: !_vm.isEditable },
                    model: {
                      value: _vm.config,
                      callback: function ($$v) {
                        _vm.config = $$v
                      },
                      expression: "config",
                    },
                  }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "bottomActions" },
        [
          _vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.cncl"),
                  variant: "secondary",
                  outline: true,
                  size: "md",
                  "custom-class": "mr-3",
                  "aria-label":
                    _vm.$t("common.cncl") +
                    " " +
                    _vm.$t("Webheader.bic_onus_edit"),
                },
                on: {
                  click: function ($event) {
                    return _vm.switchMode("details")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("administration.edit"),
                  icon: "fa-light fa-pencil",
                  variant: "primary",
                  size: "md",
                  "custom-class": "mr-2",
                  "aria-label":
                    _vm.$t("administration.edit") +
                    " " +
                    _vm.$t("common.bic.bic_onus"),
                },
                on: {
                  click: function ($event) {
                    return _vm.switchMode("edit")
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          !_vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("rights.delete"),
                  icon: "fa-light fa-trash",
                  variant: "danger",
                  size: "md",
                  "custom-class": "ml-2",
                  "aria-label":
                    _vm.$t("rights.delete") +
                    " " +
                    _vm.$t("common.bic.bic_onus"),
                },
                on: { click: _vm.deleteBICOnus },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.isEditable && _vm.formType !== "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "success",
                  size: "md",
                  "aria-label":
                    _vm.$t("common.sve") + " " + _vm.$t("common.bic.bic_onus"),
                },
                on: { click: _vm.editBICOnus },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.mode === "add"
            ? _c("app-button", {
                attrs: {
                  text: _vm.$t("common.sve"),
                  icon: "fa-light fa-save",
                  variant: "success",
                  size: "md",
                  "aria-label":
                    _vm.$t("common.sve") + " " + _vm.$t("common.bic.bic_onus"),
                },
                on: { click: _vm.addBICOnus },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }